import React from 'react'
import { Breadcrumb } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { FaHome } from 'react-icons/fa'

const BreadcrumbGF = ({ items }) => {

  const navigate = useNavigate()

  return <Breadcrumb className={`pt-3 px-4 bg-info border-bottom fw-bold`}>
    <Breadcrumb.Item onClick={() => navigate('/')}><FaHome /></Breadcrumb.Item>
    { items && items.map( (i, index) => {
      if( index === (items.length - 1) ){
        return <Breadcrumb.Item key={index} active>{i.label}</Breadcrumb.Item>
      }else{
        return <Breadcrumb.Item key={index} onClick={() => navigate(i.path)}>{i.label}</Breadcrumb.Item>  
      }
    })}        
  </Breadcrumb>
}

export default BreadcrumbGF